/**
 * Business related translations
 * Contains business translations from the original VSCode extension
 */
export default {
  // Dashboard
  'business.dashboard.title': 'Hunter Workspace Overview',
  'business.dashboard.subtitle':
    'Track hiring progress, client pipelines, and project health in one place.',
  'business.dashboard.totalTalents': 'Total Talents',
  'business.dashboard.activeJobs': 'Active Jobs',
  'business.dashboard.totalClients': 'Total Clients',
  'business.dashboard.activeProjects': 'Active Projects',
  'business.dashboard.successRateTrend': 'Placement Success Trend',
  'business.dashboard.projectStatus': 'Project Status Distribution',
  'business.dashboard.viewDetails': 'View details',
  'business.dashboard.monthlyTarget': 'Monthly Objectives',
  'business.dashboard.talentTarget': 'Talent placement target',
  'business.dashboard.projectTarget': 'Project delivery target',
  'business.dashboard.revenueTarget': 'Revenue target',
  'business.dashboard.recentActivities': 'Recent Activities',
  'business.dashboard.viewAll': 'View all',
  'business.dashboard.activity': 'Activity',
  'business.dashboard.name': 'Name',
  'business.dashboard.time': 'Time',
  'business.dashboard.status': 'Status',
  'business.dashboard.completed': 'Completed',
  'business.dashboard.processing': 'In progress',
  'business.dashboard.pending': 'Pending',
  'business.dashboard.quickActions': 'Quick Actions',
  'business.dashboard.addTalent': 'Add Talent',
  'business.dashboard.createJob': 'Create Job',
  'business.dashboard.addClient': 'Add Client',
  'business.dashboard.createProject': 'Create Project',
  'business.dashboard.loading': 'Loading dashboard data...',
  'business.dashboard.error': 'Failed to load dashboard data',
  'business.dashboard.retry': 'Retry',
  'business.dashboard.error.network':
    'Network error. Please check your connection and try again.',
  'business.dashboard.error.server': 'Server error. Please try again later.',
  'business.dashboard.error.unauthorized':
    'Authentication failed. Please check your login status.',
  'business.dashboard.noData': 'No activity records',
};
